/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceToken } from '../../models/service-token';
import { TokenRequestModel } from '../../models/token-request-model';

export interface TokenAccessTokenPost$Params {
  
    /**
     * The request payload containing the client ID and shared secret.
     */
    body?: TokenRequestModel
}

export function tokenAccessTokenPost(http: HttpClient, rootUrl: string, params?: TokenAccessTokenPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<ServiceToken>> {
  const rb = new RequestBuilder(rootUrl, tokenAccessTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<ServiceToken>;
    })
  );
}

tokenAccessTokenPost.PATH = '/Token/AccessToken';
